import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router, UrlTree } from '@angular/router';

import { AuthStore } from '../state/auth';

export const publicCanActivateFn: CanActivateFn = () => {
  return canActivatePublic();
};

export const publicCanActivateChildFn: CanActivateChildFn = () => {
  return canActivatePublic();
};

/**
 * Keeps signed-in users off the public auth pages (login, signup, password recovery).
 *
 * It only sends them to `/`; the auth guard there decides where the current stage actually
 * belongs, so the stage ⇄ route mapping stays in one place.
 */
function canActivatePublic(): boolean | UrlTree {
  const router = inject(Router);
  const authStore = inject(AuthStore);

  if (authStore.isAuthenticated()) {
    return router.parseUrl('/');
  }

  return true;
}
